export function BlockPie({ frac, color, size = 28 }) {
  const cx = size/2, cy = size/2, r = size/2 - 2, discR = r * 0.58;
  const a = frac * 2 * Math.PI;
  const path = frac >= 0.9999 ? `M ${cx} ${cy} m 0 -${r} a ${r} ${r} 0 1 1 -0.001 0 Z`
    : frac <= 0 ? `M ${cx} ${cy} Z`
    : `M ${cx} ${cy} L ${cx} ${cy - r} A ${r} ${r} 0 ${a > Math.PI ? 1 : 0} 1 ${cx + r*Math.sin(a)} ${cy - r*Math.cos(a)} Z`;

  return (
    <svg width={size} height={size} style={{ display: "block", flexShrink: 0 }}>
      <circle cx={cx} cy={cy} r={r} fill={`${color}18`} />
      <path d={path} fill={color} opacity={0.75} />
      <circle cx={cx} cy={cy} r={discR} fill="white" />
    </svg>
  );
}

export default BlockPie;
